// src/store/podSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchPods = createAsyncThunk('pods/fetchAll', async () => {
  const res = await axios.get('https//api.monkeybox.ai/api/pods');
  return res.data;
});

export const createPod = createAsyncThunk('pods/create', async (formData) => {
  const res = await axios.post('https//api.monkeybox.ai/api/pods', formData);
  return res.data;
});

const podSlice = createSlice({
  name: 'pods',
  initialState: {
    pods: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPods.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPods.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pods = action.payload;
      })
      .addCase(fetchPods.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(createPod.fulfilled, (state, action) => {
        state.pods.unshift(action.payload);
      });
  },
});

export default podSlice.reducer;
